import cx from 'classnames';
import type { CSSProperties } from 'react';

import styles from './Button.module.sass';

export type ButtonVariants = 'primary' | 'secondary' | 'outlined';

interface ButtonProps {
  variant?: ButtonVariants;
  type?: HTMLButtonElement['type'];
  text: string;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}
const Button = ({ type = 'button', variant = 'primary', text, disabled, className, style, onClick = () => { } }: ButtonProps) => {
  const classes = cx(styles.button, styles[`button--${variant}`], className);

  return (
    <button type={type} disabled={disabled} className={classes} style={style} onClick={onClick}>
      {text}
    </button>
  );
};

export default Button;
